"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockList = void 0;
function mockList(overrides = {}) {
    return {
        ambassador_code: null,
        description: 'Mock description',
        id: 1,
        meta_description: null,
        meta_title: null,
        products: [],
        shop_the_list_title: 'Mock shop the list title',
        subtitle: 'Mock List subtitle',
        title: 'Mock List',
        url_slug: 'mock_List',
        ...overrides,
    };
}
exports.mockList = mockList;
